import React from "react";
import "./LeaveButton.css";

const LeaveButton = ({ onClick }) => {
  return (
    <button
      className="LeaveButton"
      onClick={onClick}
    >
      Opuść stronę
    </button>
  );
};

export default LeaveButton;
